module.exports = __webpack_public_path__ + "img/Users.e196056f.svg";